module.exports = __webpack_public_path__ + "img/aqjg.bcdc5767.png";